import axiosInstance from '../mainService';
const companyService = {
    async fetchCompany() {
        try {
            const response = await axiosInstance.get('/company');
            return response.data;
        } catch (error) {
            console.error('Error fetching company:', error);
            throw error;
        }
    }
}
export default companyService;
